import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../shared/utils/error';
import UsuariosScreen from './screen';
import { UsuariosAdapter, Usuario } from '../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../shared/hooks/Notifications';

const UsuariosContainer = (props:any) => {

	const {translate} = props;
	const api = new UsuariosAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();

	let [ usuarios, setUsuarios ] = useState<any>([]);
	let [permisosUser, setPermisosUser] = useState<any>([]);
	let result: any;

	useEffect(() => {
		getUsuarios();
	}, []);

	const getUsuarios = async () => {
		try {
			result = await api.ListarTodosUsuarios();
			if(result.data && result.data!=="")
			{
				setUsuarios([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const createUsuario = async (usuario: any) => {
		try {
			const result:any = await api.CrearUsuario(usuario);
			if(result.data && result.data!=="")
			{
				setUsuarios([ ...usuarios,...result.data ] || []);
				launchNotification({type:"success",title:translate('creacion'),message:`${translate('msg-notificacion-crear-usuario')}.`})
			}else{
				resultError()
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	// const deleteUsuario = async (dni: string) => {
	// 	try {
	// 		result = await api.EliminarUsuario(dni);
	// 		if(result.data && result.data!=="")
	// 		{
	// 			let pos = usuarios.findIndex((u: Usuario) => u.dni === dni);
	// 			let newData = [ ...usuarios ];
	// 			newData.splice(pos, 1);
	// 			setUsuarios([ ...newData ] || []);
	// 			launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado un usuario."})
	// 		}else{resultError()}
	// 	} catch (error) {
	// 		let exception = ServerErrorMessage(error);
	// 		exceptionError(exception)
	// 	}
	// };

	const updateUsuario = async (dniOld:any, usuario: any, configuracionRolExpatriado: string) => {
		const _usuario = {usuario:usuario,configuracionRolExpatriado:configuracionRolExpatriado}
		try {
			result = await api.ModificarUsuario(dniOld,_usuario);
			if(result.data && result.data!=="")
			{
				let pos = usuarios.findIndex((u: Usuario) => u.dni === usuario.dni);
				let newData = [ ...usuarios ];
				newData[pos] = {...result.data[0],id:usuario.id};
				setUsuarios([ ...newData ] || []);
				launchNotification({type:"success",title:translate('modificacion'),message:`${translate('msg-notificacion-modificar-usuario')}.`})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const addDelegadosUsuario = async (dni:string,delegados: string) => {
		try {
			const result:any = await api.AgregarDelegadosUsuario(dni,delegados);
			if(result.data && result.data!=="")
			{
				let pos = usuarios.findIndex((u: Usuario) => u.dni === dni);
				let newData = [ ...usuarios ];
				newData[pos] = result.data[0];
				setUsuarios([ ...newData ] || []);
				launchNotification({type:"success",title:translate('creacion'),message:"Se han cambiado los delegados a un usuario."})
			}else{
				resultError()
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	return(
		<>
		<UsuariosScreen
			data={usuarios}
			permisosUser={permisosUser}
			handleCreate={createUsuario}
			//handleRemove={deleteUsuario}
			handleUpdate={updateUsuario}
			handleAddDelegados={addDelegadosUsuario}
			{...props}
		/>
		</>
	);
};

export default UsuariosContainer;
